import { StockValidationConstants } from './StockValidation.constants';

const initialState = {
    selectedStore: ''
};

const StockValidationReducer = (state = initialState, action) => {
    switch (action.type) {
        case StockValidationConstants.APPLIED_STORE_FILTER:
            return {
                ...state,
                selectedStore: action.payload
            }
        default:
            return state;
    }
}

export default StockValidationReducer;